/**
 * Polyfill for Object.fromEntries (ES2019) for older browsers (e.g. Mobile Safari 12).
 * Runs before any application or dependency code. Safe to run in modern browsers (no-op if present).
 * See: ECOM-878
 */
export default defineNuxtPlugin(() => {
  if (typeof Object.fromEntries === 'function') {
    return
  }

  // Spec-compliant polyfill: accepts iterable of [key, value] pairs.
  // Uses only ES5 + ES2015 (Array.from, reduce) for Safari 12 compatibility.
  Object.defineProperty(Object, 'fromEntries', {
    configurable: true,
    enumerable: false,
    writable: true,
    value: function fromEntries<T>(
      iterable: Iterable<readonly [string, T]>,
    ): Record<string, T> {
      if (iterable == null) {
        throw new TypeError('Object.fromEntries requires an iterable')
      }
      const entries = Array.from(iterable)
      const result: Record<string, T> = {}
      for (let i = 0; i < entries.length; i++) {
        const entry = entries[i]
        if (entry != null && typeof entry === 'object' && entry.length >= 2) {
          result[String(entry[0])] = entry[1] as T
        }
      }
      return result
    },
  })
})
